import type { ApplicantCount } from 'src/graphql/graphql';
import { useApplicantInsightNumberOfApplicantsFeatureFlag } from 'src/store/featureFlags/hooks';

export const useNumberOfApplicants = (applicantCount: ApplicantCount) => {
  const { countLabel, volumeLabel } = applicantCount;

  const applicationVolumeJdpFeatureFlag =
    useApplicantInsightNumberOfApplicantsFeatureFlag();
  const applicationVolumeLabel = getNumberOfApplicantsLabel({
    countLabel,
    volumeLabel,
    flag: applicationVolumeJdpFeatureFlag,
  });

  return {
    applicationVolumeLabel,
    enableNumberOfApplicants:
      applicationVolumeJdpFeatureFlag === 'volume' ||
      applicationVolumeJdpFeatureFlag === 'count',
  };
};

export const getNumberOfApplicantsLabel = ({
  countLabel,
  volumeLabel,
  flag,
}: {
  countLabel?: string | null;
  volumeLabel?: string | null;
  flag: ReturnType<typeof useApplicantInsightNumberOfApplicantsFeatureFlag>;
}): string | undefined => {
  switch (flag) {
    case 'control':
      return undefined;

    case 'volume':
      return volumeLabel ?? undefined;

    case 'count':
      return countLabel ?? undefined;

    default:
      return undefined;
  }
};
